import { render, staticRenderFns } from "./MediaTargetingData.vue?vue&type=template&id=25b0d9ba&scoped=true"
import script from "./MediaTargetingData.vue?vue&type=script&lang=js"
export * from "./MediaTargetingData.vue?vue&type=script&lang=js"
import style0 from "./MediaTargetingData.vue?vue&type=style&index=0&id=25b0d9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b0d9ba",
  null
  
)

export default component.exports